import { Tenant } from '../../declarations/tenant.interface';

export interface TenantState {
  currentTenant: Tenant | 'loading';
}

export const initialState: TenantState = {
  currentTenant: 'loading'
};
